module.exports = __webpack_public_path__ + "img/top2.e9de66b9.png";